<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/financeLoan/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width"
               label-width="100px">
        <el-form-item label="客户姓名" prop='userName'>
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户姓名" />
        </el-form-item>
        <el-form-item label="类型" prop='depositType'>
          <el-select clearable v-model="searchForm.depositType" placeholder="请选择类型">
            <el-option label="贷款" value="1"></el-option>
            <el-option label="还款" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="180" :show-overflow-tooltip="true" label="客户姓名" prop="userName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="类型" prop="depositType">
          <template v-slot="{ row }">
            {{ row.depositType === '1' ? '贷款' : row.depositType === '2' ? '还款' : '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="金额" prop="depositChange"></el-table-column>
        <el-table-column min-width="180" :show-overflow-tooltip="true" label="创建时间" prop="ctime"></el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/financeLoan/detail?loanId=' + row.loanId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
                       @click="$router.push('/financeLoan/edit?loanId=' + row.loanId)">编辑</el-button>
            <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.loanId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'FinanceLoan',
  mixins: [keepAlive],
  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userName: '',
        depositType: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.financeLoan.selectYxFinanceLoanByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(loanId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.financeLoan.deleteDataYxFinanceLoan, {
          loanId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}
</style>
<style lang='scss'>
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
